// @flow

import { logger, getQuery, tryParse } from '../common'

import { IFRAME_ORIGIN } from '../common/iframeParameters'
import { sendRestartMessage } from './utils/api'

export const IFRAME_MESSAGES = {
  SCROLL_PERCENT: 'scroll-percent',
  RESIZE: 'resize'
}

// DEPRECATED, please migrate to above structure
export const EVENT_START_CHATBOT = 'start-chatbot'
export const EVENT_CLOSE_CHATBOT = 'close-chatbot'
export const EVENT_REPEAT = 'repeat'
export const EVENT_PARENT_URL_UPDATED = 'parent-url'
export const EVENT_CUSTOMER_SUPPORT = 'customer-support'
export const EVENT_EXIT_INTENT = 'exit-intent'
export const EVENT_AFTER_ADDING_PRODUCTS_TO_CART = 'after-adding-product-to-cart'
export const EVENT_FAILED_TO_ADD_PRODUCTS_TO_CART = 'failed-to-add-products-to-cart'
export const EVENT_POSTHOG_TOOLBAR = 'posthog-toolbar'

export function initMessageBus (store: any): void {
  window.addEventListener('message', e => _handleMessage(store, e))
}

function handleEventScrolled (store: any, payload: Object): void {
  store.commit('setScrollPercent', payload?.scrollPercent)
  if (!store.state.welcomeMessage?.welcomeMessage) store.dispatch('pickWelcomeMessage')
}

function handleEventResized (store: any, payload: Object): void {
  if (payload.isMobile) document.body?.classList.add('is-mobile')
  else document.body?.classList.remove('is-mobile')
}

const eventHandlers = {
  [IFRAME_MESSAGES.SCROLL_PERCENT]: handleEventScrolled,
  [IFRAME_MESSAGES.RESIZE]: handleEventResized
}

// Export only for unit test
export function _handleMessage (store: any, e: MessageEvent) {
  const parentOrigin = getQuery(IFRAME_ORIGIN)

  if (e.origin === parentOrigin && e.isTrusted) {
    const payload = tryParse(String(e.data), { parentEvent: null })

    const handler = eventHandlers[payload.parentEvent]

    if (handler) {
      handler(store, payload)
    } else {
      // DEPRECATED; migrate to event handlers
      switch (payload.parentEvent) {
        case EVENT_EXIT_INTENT:
          store.dispatch('exitIntent')
          break
        case EVENT_CUSTOMER_SUPPORT:
          store.commit('setCustomerSupport', payload.customerSupport)
          break
        case EVENT_PARENT_URL_UPDATED:
          if (store.state.parentUrl === payload.parentUrl) return

          logger.info(`Parent url was updated to ${payload.parentUrl}.`)
          store.commit('setParentUrl', payload.parentUrl)
          store.dispatch('pickWelcomeMessage')
          break
        case EVENT_START_CHATBOT:
          store.dispatch('start')
          break
        case EVENT_CLOSE_CHATBOT:
          store.dispatch('close')
          break
        case EVENT_REPEAT:
          sendRestartMessage(payload.payload)
            .catch((err) => logger.error(err))
          break
        case EVENT_AFTER_ADDING_PRODUCTS_TO_CART:
          store.commit('setProductAddingToCart', null)
          store.commit('setRoutineAddingToCart', false)
          payload.productIds.split(',').forEach(productId => {
            store.commit('addProductToCart', productId.trim())
          })
          break
        case EVENT_FAILED_TO_ADD_PRODUCTS_TO_CART:
          store.commit('setProductAddingToCart', null)
          store.commit('setRoutineAddingToCart', false)
          break
        case EVENT_POSTHOG_TOOLBAR: {
          window.vueInstance.$posthog.feature_flags.override(payload.variants)
          // Thiago; 12.04.2023; It is a workaround to re-render the whole chatbot
          // in order to use new feature flags coming from the posthog toolbar
          const mainComponent = window.vueInstance.$children[0]
          if (mainComponent && mainComponent.$store.state.bubble.isOpen) {
            mainComponent.toggleChat()
            setTimeout(() => mainComponent.toggleChat(), 1000)
          }
          break
        }
        default:
          break
      }
    }
  }
}
